import { render } from "./Conversations.vue?vue&type=template&id=1b5cb634&scoped=true"
import script from "./Conversations.vue?vue&type=script&lang=js"
export * from "./Conversations.vue?vue&type=script&lang=js"

import "./Conversations.vue?vue&type=style&index=0&id=1b5cb634&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5cb634"]])

export default __exports__